module.exports = __webpack_public_path__ + "img/offers2.5ac11b40.jpg";